import * as actions from "./actionsTypes";

const initialData = {
  loading: false,
  saveLoading: false,
  disciplinaryActionTypesLength: 0,
  disciplinaryActionTypes: [],
  disciplinaryActionTypesError: "",
  formError: "",
};

export default function DisciplinaryActionTypesReducer(state = initialData,action) {
  switch (action.type) {
    case actions.LOADING_DISCIPLINARY_ACTION_TYPES:
      return { ...state, loading: action.payload };
    case actions.SAVE_LOADING_DISCIPLINARY_ACTION_TYPES:
      return { ...state, saveLoading: action.payload };
    case actions.GET_DISCIPLINARY_ACTION_TYPES:
      return {
        ...state,
        disciplinaryActionTypes: action.payload.disciplinaryActionTypes,
        disciplinaryActionTypesLength: action.payload.disciplinaryActionTypesLength,
      };
    case actions.FORM_FAIL:
      return { ...state, formError: action.payload };
    case actions.DISCIPLINARY_ACTION_TYPES_FAIL:
      return { ...state, disciplinaryActionTypesError: action.payload };
    default:
      return state;
  }
}
